var map = {
	"./Spoon-fork-knife-icon.png": "1350",
	"./atout.png": "6469",
	"./background/pubag-back.png": "8083",
	"./bagsBa.png": "1726",
	"./bakery-bags-prime.png": "b883",
	"./bakery-bags.png": "fdac",
	"./chevron-down.png": "0fc3",
	"./dashboard.png": "a623",
	"./exemple4.png": "54dd",
	"./logo-mini.png": "a2c8",
	"./logo.png": "9d64",
	"./pharma-bags-prime.png": "aa02",
	"./pharma-bags.png": "3312",
	"./pubag-logo.png": "6967",
	"./references/bte.png": "be5a",
	"./references/business.png": "5b47",
	"./references/dclean.png": "3970",
	"./references/hana.png": "f4e3",
	"./references/maesteria.png": "07fc",
	"./references/minenv.png": "1bc4",
	"./references/pazzino.png": "524e",
	"./references/sos.png": "b2b2",
	"./references/topx.png": "f630",
	"./references/z.png": "ed63",
	"./team-map-position.png": "a52a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";